import React from 'react';
import PropTypes from 'prop-types';
import FormCard from '../../../../../../Lib/FormCard';
import FormInput from '../../../../../../Lib/FormInput';

const ContactForm = ({ 
  formData, 
  onChange, 
  errors, 
  disabled, 
  index = 0 ,
  refs
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  return (
    <FormCard
      title={index > 0 ? `Contact Details ${index}` : "Contact Details"}
    >
      <div className="col-md-6">
        <FormInput
          ref={refs?.email}
          label="Email"
          icon="bi bi-envelope"
          placeholder="example@email.com"
          value={formData.email}
          onChange={handleInputChange}
          name="email"
          disabled={disabled}
          error={errors.email}
          required={true}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          label="Country"
          icon="bi bi-map"
          placeholder="Country"
          value={formData.country}
          onChange={handleInputChange}
          name="country"
          disabled={disabled}
          error={errors.country}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          label="State"
          icon="bi bi-layers"
          placeholder="State"
          value={formData.state}
          onChange={handleInputChange}
          name="state"
          disabled={disabled}
          error={errors.state}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          label="City"
          icon="bi bi-mailbox"
          placeholder="City"
          value={formData.city}
          onChange={handleInputChange}
          name="city"
          disabled={disabled}
          error={errors.city}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          label="Zipcode"
          icon="bi bi-file-zip"
          placeholder="Zipcode"
          value={formData.zipcode}
          onChange={handleInputChange}
          name="zipcode"
          disabled={disabled}
          error={errors.zipcode}
        />
      </div>
      <div className="col-md-12 mb-3">
        <div className="form-group">
          <label className="form-label text-muted">Address</label>
          <textarea
            className={`form-control ${errors.address ? "is-invalid" : ""}`}
            placeholder="Address"
            value={formData.address}
            onChange={handleInputChange}
            name="address"
            disabled={disabled}
          ></textarea>
          {errors.address && (
            <div className="invalid-feedback">{errors.address}</div>
          )}
        </div>
      </div>
    </FormCard>
  );
};

ContactForm.propTypes = {
  formData: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  index: PropTypes.number
};

export default ContactForm;